'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_ClientSideAuthFailure$InvalidEmail(email) {
  this.Lapp_auth_ClientSideAuthFailure$InvalidEmail__f_email = null;
  this.Lapp_auth_ClientSideAuthFailure$InvalidEmail__f_email = email;
}
export { $c_Lapp_auth_ClientSideAuthFailure$InvalidEmail as $c_Lapp_auth_ClientSideAuthFailure$InvalidEmail };
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.constructor = $c_Lapp_auth_ClientSideAuthFailure$InvalidEmail;
/** @constructor */
function $h_Lapp_auth_ClientSideAuthFailure$InvalidEmail() {
}
export { $h_Lapp_auth_ClientSideAuthFailure$InvalidEmail as $h_Lapp_auth_ClientSideAuthFailure$InvalidEmail };
$h_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype = $c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype;
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-494117189), true);
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_auth_ClientSideAuthFailure$InvalidEmail) && (this.Lapp_auth_ClientSideAuthFailure$InvalidEmail__f_email === x$0.Lapp_auth_ClientSideAuthFailure$InvalidEmail__f_email)));
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.productPrefix__T = (function() {
  return "InvalidEmail";
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_auth_ClientSideAuthFailure$InvalidEmail__f_email;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_auth_ClientSideAuthFailure$InvalidEmail.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "email";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_auth_ClientSideAuthFailure$InvalidEmail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_auth_ClientSideAuthFailure$InvalidEmail)));
}
export { $isArrayOf_Lapp_auth_ClientSideAuthFailure$InvalidEmail as $isArrayOf_Lapp_auth_ClientSideAuthFailure$InvalidEmail };
var $d_Lapp_auth_ClientSideAuthFailure$InvalidEmail = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_ClientSideAuthFailure$InvalidEmail, "app.auth.ClientSideAuthFailure$InvalidEmail", ({
  Lapp_auth_ClientSideAuthFailure$InvalidEmail: 1,
  Lapp_auth_ClientSideAuthFailure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_auth_ClientSideAuthFailure$InvalidEmail as $d_Lapp_auth_ClientSideAuthFailure$InvalidEmail };
//# sourceMappingURL=app.auth.-Client-Side-Auth-Failure$-Invalid-Email.js.map
